import type { BBRepoPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const toFieldValue = (repos: BBRepoPickerOption[]) => repos.map(({ uuid }) => uuid);
